<script setup lang="ts">
import type { HouseDetails } from '~/types/house/types'

const props = defineProps<{
  house: HouseDetails
}>()

const isLicense = computed(() => Boolean(props.house.licenceNumber))
</script>

<template>
  <div>
    <h2 class="mb-5 text-2xl">
      {{ $t('house.additionalInformation.title') }}
    </h2>

    <div class="mb-5 flex justify-between pr-8 md:justify-normal md:pr-0">
      <div class="flex items-center md:mr-20">
        <BaseIcon class="mr-4" name="calendar" />
        <div class="text-md">
          <div class="font-semibold">Check-in</div>
          <span class="lg:text-gray-500">{{
            house.stayInformation.checkInTime
          }}</span>
        </div>
      </div>

      <div class="flex items-center">
        <BaseIcon class="mr-4" name="calendar" />
        <div class="text-md">
          <div class="font-semibold">Check-out</div>
          <span class="lg:text-gray-500">{{
            house.stayInformation.checkOutTime
          }}</span>
        </div>
      </div>
    </div>

    <ul class="m-0 p-0">
      <li
        v-if="house.stayInformation.suitableForPeopleWithReducedMobility"
        class="mb-4 flex items-center"
      >
        <BaseIcon class="mr-3 rounded-full bg-beige" name="check" />
        <span class="text-gray-600">
          {{
            $t(
              'house.additionalInformation.suitableForPeopleWithReducedMobility',
            )
          }}
        </span>
      </li>
      <li
        v-if="house.stayInformation.suitableForChildren"
        class="mb-4 flex items-center"
      >
        <BaseIcon class="mr-3 rounded-full bg-beige" name="check" />
        <span class="text-gray-600">
          {{ $t('house.additionalInformation.suitableForChildren') }}
        </span>
      </li>
      <li class="mb-0 flex items-center">
        <BaseIcon class="mr-3 rounded-full bg-beige" name="check" />
        <span class="text-gray-600">
          {{ $t('house.cleaningIncluded') }}
        </span>
      </li>
    </ul>
    <div v-if="isLicense" class="mt-9">
      <p class="m-0 text-md font-normal text-gray-500">
        {{ $t('house.licence.licence_number') }}
        <span> {{ house.licenceNumber }} </span>
      </p>
    </div>
  </div>
</template>
